// extracted by mini-css-extract-plugin
module.exports = {"contentBoardLayout":"styles_contentBoardLayout__2XfWs"};